module.exports = __webpack_public_path__ + "static/media/amicafarmacia.73cecd56.svg";